import React, { useEffect, useRef, useState } from "react";
import FormHeader from "./FormHeader";
import Button from "../../../components/common/ui/Button";
import { CheckBoxInput, TextInput } from "../../../components/common/ui/Inputs";
import Table from "../../../components/common/table/Table";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import CommonModal from "../../../components/common/ui/NotificationModal/CommonModal";
import { useLocation } from "react-router-dom";
import { masterActions, staffRequestAction } from "../../../_store";
import SignatureCanvas from "react-signature-canvas";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import { feedbackSchema } from "../../../validation/staffRequestSchema";
import { history } from "../../../_helpers";
import { Popup } from "../../../components/common/ui/NotificationModal/Popup";
import PublicDefenderLogo from "../../../assets/georgia.png";
import deleteimg from "../../../assets/svg/delete-button.svg";
import { getCurrentDate } from "../../../utils/formatTime";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import DefenderFormHeader from "./DefenderFormHeader";
import { handleReviewRequestFormNavigation } from "./ReviewRequestFormNavigator";
import CustomLoader from "../../../components/common/ui/Loader";
import { getStoredValue, setStoredValue } from "../../../_helpers/storagehelper";

function PublicDefenderServiceForm() {
    const componentRef = useRef();
    const location = useLocation();
    const dispatch = useDispatch();
    const sigCanvas = useRef({});

    const formID = location?.state ? location?.state?.formID : 0;
    const formDetails = location?.state ? location?.state?.formDetails : {};

    const sessionFeedbackList = getStoredValue("feedbackList") || [];

    const sourceFrom = location?.state ? location?.state?.sourceFrom : "";

    const {
        requestReview,
        publicDefenderList,
        crispFormDetailsResponse,
        startProcessingResponse,
        staffRequestDefenderSearchList,
        indexValue,
        reviewList,
        loading,
    } = useSelector((x) => x?.staffRequest);

    const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
    const loggedUser = getStoredValue("user")?.ManagementUserID;

    const stateList = useSelector((x) => x?.master?.stateDrpList);

    const stateName = stateList?.filter(
        (item, index) =>
            item?.value === parseInt(crispFormDetailsResponse?.StateName)
    );

    const [requestFormSubmitted, setRequestFormSubmitted] = useState(false);


    const managementUserID = getStoredValue("user")?.ManagementUserID;

    // const [facilityName, setFacilityName] = useState("");

    const [submittedFormList, setSubmittedFormList] = useState([]);

    const [sign, setSign] = useState("");

    const [tempFeedBackList, setTempFeedBackList] = useState(sessionFeedbackList);

    const [permananentFeedBackList, setPermananentFeedBackList] =
        useState(sessionFeedbackList);

    const [isShowApprovedBtn, setIsShowApprovedBtn] = useState(false);

    const [isShowRejectBtn, setIsShowRejectBtn] = useState(false);

    const [isShowResubmitBtn, setIsShowResubmitBtn] = useState(false);

    const [isShowStartProcessingBtn, setIsShowStartProcessingBtn] =
        useState(false);

    const [isShowBackBtn, setIsShowBackBtn] = useState(false);

    const [errorMessage, setErrorMessage] = useState({});

    const [PDStaffAssignAccept, setPDStaffAssignAccept] = useState(0);

    const [closePopup, setClosePopup] = useState(false);

    const [signError, setSignError] = useState(false);

    const prevFacilityCodeRef = useRef(facilityCode);

    const currentDate = getCurrentDate();
    const spliteDate = currentDate?.split("/");
    const month = spliteDate?.[0];
    const date = spliteDate?.[1];

    function getDateWithSuffix(date) {
        if (date < 1 || date > 31) return "Invalid date";

        const suffixes = [" th", " st", " nd", " rd"];
        const v = date % 100;
        const suffix = suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];

        return `${date}${suffix}`;
    }

    const day = getDateWithSuffix(date);
    const year = spliteDate?.[2];

    const monthList = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    useEffect(() => {
        dispatch(staffRequestAction?.resetForm());
        if (formID) {
            getPublicDefenderCrispForm();

            setIsShowApprovedBtn(false);
            setIsShowRejectBtn(false);
            setIsShowResubmitBtn(false);
            // setIsShowStartProcessingBtn(false);
        }
    }, [formID]);

    useEffect(() => {
        if (prevFacilityCodeRef.current !== facilityCode) {
            history.navigate(sourceFrom);
        }
    }, [facilityCode]);

    //load facility drop down
    useEffect(() => {
        dispatch(
            masterActions.LoadFacilityDropDown({
                facilityID: 0,
                activeStatus: 1,
            })
        )
            .then((data) => {
                const facilityList = data?.payload;
                const facilityName = facilityList?.find(
                    (x) => x?.value === facilityCode
                )?.label;
                // setFacilityName(facilityName);
            })
            .catch(() => {
                // setFacilityName("");
            });
    }, []);

    useEffect(() => {
        if (startProcessingResponse?.IsSucceed > 0 && PDStaffAssignAccept === 1) {
            showToastNotification("Accepted  successfully", "success");
            getPublicDefenderCrispForm();
            setRequestFormSubmitted(true);
            dispatch(staffRequestAction?.resetForm());
        }

        if (startProcessingResponse?.IsSucceed > 0 && PDStaffAssignAccept === 0) {
            showToastNotification("Rejected successfully", "success");
            dispatch(staffRequestAction?.resetForm());
            if (!requestReview) {
                history.navigate("/Admin/StaffRequestList");
                getPublicDefenderCrispForm();
            }
        }

        switch (startProcessingResponse?.IsSucceed) {
            case -1:
                showToastNotification("Error Occured Please try again", "error");
                dispatch(staffRequestAction?.resetForm());
                break;

            case -2:
                showToastNotification("Form already approved", "warning");
                dispatch(staffRequestAction?.resetForm());
                break;

            case -3:
                showToastNotification(
                    "Already this form was processed by another user.",
                    "warning"
                );
                dispatch(staffRequestAction?.resetForm());
                break;

            default:
                break;
        }
    }, [startProcessingResponse]);

    const getPublicDefenderCrispForm = () => {
        dispatch(staffRequestAction?.getCrispFormDetails(formID))
            .then((result) => {
                if (result?.payload) {
                    const formDetails = result?.payload;
                    //1
                    if (
                        formDetails?.IsPdStaffReSubmited === 1 &&
                        formDetails?.IsFormAcceptPdStaff === 1 &&
                        formDetails?.IsFormApprovedPdStaff !== 1
                    ) {
                        setIsShowApprovedBtn(true);
                        setIsShowRejectBtn(true);
                        setIsShowResubmitBtn(true);
                        setIsShowBackBtn(true);
                        setIsShowStartProcessingBtn(false);
                    } else if (
                        formDetails?.IsPdStaffReSubmited === 1 ||
                        formDetails?.IsFormApprovedPdStaff === 1 ||
                        formDetails?.IsInmateReSubmited === 0 ||
                        formDetails?.PdfFormStatus === "Closed"
                    ) {
                        setIsShowApprovedBtn(false);
                        setIsShowRejectBtn(false);
                        setIsShowResubmitBtn(false);
                        setIsShowBackBtn(false);
                        setIsShowStartProcessingBtn(false);
                    } else if (formDetails?.IsFormAcceptPdStaff === 1) {
                        setIsShowApprovedBtn(true);
                        setIsShowRejectBtn(true);
                        setIsShowResubmitBtn(true);
                        setIsShowBackBtn(true);
                        setIsShowStartProcessingBtn(false);
                    } else {
                        setIsShowStartProcessingBtn(true);
                        setIsShowBackBtn(true);
                    }
                    dispatch(masterActions?.GetStateList());
                }
            })
            .catch((err) => {
                showToastNotification("Failed to get State value", "error");
            });
    };

    const data = [
        {
            home: crispFormDetailsResponse?.AuthorizationName1,
            number: crispFormDetailsResponse?.AuthorizationNumber1,
            relationship:
                crispFormDetailsResponse?.AuthorizationRelationship1 === "1"
                    ? "Father"
                    : crispFormDetailsResponse?.AuthorizationRelationship1 === "2"
                        ? "Mother"
                        : crispFormDetailsResponse?.AuthorizationRelationship1 === "3"
                            ? "Brother"
                            : crispFormDetailsResponse?.AuthorizationRelationship1 === "4"
                                ? "Sister"
                                : crispFormDetailsResponse?.AuthorizationRelationship1 === "5"
                                    ? "Wife"
                                    : crispFormDetailsResponse?.AuthorizationRelationship1 === "0"
                                        ? ""
                                        : crispFormDetailsResponse?.AuthorizationRelationship1 +
                                        " " +
                                        "(Others)",
        },
        {
            home: crispFormDetailsResponse?.AuthorizationName2,
            number: crispFormDetailsResponse?.AuthorizationNumber2,
            relationship:
                crispFormDetailsResponse?.AuthorizationRelationship2 === "1"
                    ? "Father"
                    : crispFormDetailsResponse?.AuthorizationRelationship2 === "2"
                        ? "Mother"
                        : crispFormDetailsResponse?.AuthorizationRelationship2 === "3"
                            ? "Brother"
                            : crispFormDetailsResponse?.AuthorizationRelationship2 === "4"
                                ? "Sister"
                                : crispFormDetailsResponse?.AuthorizationRelationship2 === "5"
                                    ? "Wife"
                                    : crispFormDetailsResponse?.AuthorizationRelationship2 === "0"
                                        ? ""
                                        : crispFormDetailsResponse?.AuthorizationRelationship2 +
                                        " " +
                                        "(Others)",
        },
        {
            home: crispFormDetailsResponse?.AuthorizationName3,
            number: crispFormDetailsResponse?.AuthorizationNumber3,
            relationship:
                crispFormDetailsResponse?.AuthorizationRelationship3 === "1"
                    ? "Father"
                    : crispFormDetailsResponse?.AuthorizationRelationship3 === "2"
                        ? "Mother"
                        : crispFormDetailsResponse?.AuthorizationRelationship3 === "3"
                            ? "Brother"
                            : crispFormDetailsResponse?.AuthorizationRelationship3 === "4"
                                ? "Sister"
                                : crispFormDetailsResponse?.AuthorizationRelationship3 === "5"
                                    ? "Wife"
                                    : crispFormDetailsResponse?.AuthorizationRelationship3 === "0"
                                        ? ""
                                        : crispFormDetailsResponse?.AuthorizationRelationship3 +
                                        " " +
                                        "(Others)",
        },
    ];

    const columns = [
        {
            name: (
                <div
                    className="d-flex  gap-1 "
                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                        ? {
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#public-defender-crisp-correction-modal",
                        }
                        : "")}
                    onClick={() => addFeedback(69)}
                >
                    <span
                        className={`crisp-grid-round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                            crispFormDetailsResponse?.PdsFormOpenStatus === 1
                            ? "animate-opacity"
                            : ""
                            }`}
                    >
                        69
                    </span>{" "}
                    Home{" "}
                </div>
            ),
            selector: (row) => row.home,
            sortable: false,
        },
        {
            name: (
                <div
                    className="d-flex  gap-1 "
                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                        ? {
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#public-defender-crisp-correction-modal",
                        }
                        : "")}
                    onClick={() => {
                        if (
                            crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                            crispFormDetailsResponse?.PdsFormOpenStatus === 1
                        ) {
                            addFeedback(70);
                        }
                    }}
                // onClick={() => addFeedback(70)}
                >
                    <span
                        className={`crisp-grid-round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                            crispFormDetailsResponse?.PdsFormOpenStatus === 1
                            ? "animate-opacity"
                            : ""
                            }`}
                    >
                        70
                    </span>
                    Number{" "}
                </div>
            ),
            selector: (row) => row.number,
            sortable: false,
        },
        {
            name: (
                <div
                    className="d-flex  gap-1 "
                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                        ? {
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#public-defender-crisp-correction-modal",
                        }
                        : "")}
                    onClick={() => {
                        if (
                            crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                            crispFormDetailsResponse?.PdsFormOpenStatus === 1
                        ) {
                            addFeedback(71);
                        }
                    }}
                // onClick={() => addFeedback(71)}
                >
                    <span
                        className={`crisp-grid-round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                            crispFormDetailsResponse?.PdsFormOpenStatus === 1
                            ? "animate-opacity"
                            : ""
                            }`}
                    >
                        71
                    </span>{" "}
                    Relationship{" "}
                </div>
            ),
            selector: (row) => row.relationship,
            sortable: false,
        },
    ];

    const addFeedBackColumn = [
        {
            name: "Delete",
            selector: (row) => row.delete,
            cell: (row, i) => (
                <CheckBoxInput
                    handleClick={(e) => {
                        selectRowForDelete(e, i);
                    }}
                    checked={permananentFeedBackList?.[i]?.["isSelect"]}
                />
            ),
            sortable: false,
        },
        {
            name: "Item #",
            selector: (row) => row.notesSNo,
            cell: (row) => (
                <TextInput
                    placeholder="Select Item"
                    disabled
                    value={row?.notesSNo}
                    readonly
                />
            ),
            sortable: false,
        },
        {
            name: "Notes",
            selector: (row, i) => row.notesRemarks,
            cell: (row, i) => (
                <TextInput
                    name={`feedback-${i}-notesRemarks`}
                    handleChange={(e) => handleNotesChange(e, i)}
                    value={
                        permananentFeedBackList?.[i]?.["notesRemarks"] !== ""
                            ? permananentFeedBackList?.[i]?.["notesRemarks"]
                            : ""
                    }
                    // value={permananentFeedBackList?.[i]?.["notesRemarks"]}
                    placeholder="Enter Notes"
                    errorMessage={errorMessage}
                    maxLength={50}
                    handleBlur={handleFeedBackBlur}
                />
            ),
            sortable: false,
        },
    ];

    const feedbackColumn = [
        {
            name: "Item #",
            selector: (row) => row.NotesSNo,

            sortable: false,
        },
        {
            name: "Date",
            selector: (row) => row.PdsNotesDate,
            cell: (row, i) => (
                <div>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                    <span>{row.PdsNotesDate}</span>
                </div>
            ),

            sortable: false,
        },
        {
            name: "Notes",
            selector: (row) => row.NotesRemarks,

            sortable: false,
        },
        {
            name: "Feedback By",
            selector: (row, i) => row?.ReSubmittedBy,
            sortable: false,
        },
    ];

    // const handleNotesChange = (e, i) => {
    //   const { value } = e?.target;
    //   //changes saved in temp list
    //   const tempList = [...tempFeedBackList];
    //   if (checkTempArrHasValue(tempList)) {
    //     //update permanent arr list
    //     const permanenetList = [...permananentFeedBackList];
    //     permanenetList[i]["notesRemarks"] = value;
    //     setPermananentFeedBackList(permanenetList);
    //   } else {
    //     //update both arr
    //     const permanenetList = [...permananentFeedBackList];
    //     permanenetList[i]["notesRemarks"] = value;
    //     setPermananentFeedBackList(permanenetList);
    //     tempList[i]["notesRemarks"] = value;
    //     setTempFeedBackList(tempList);
    //   }
    // };

    const handleNotesChange = (e, i) => {
        const { value } = e?.target;

        // Create a copy of the lists
        const permanentList = [...permananentFeedBackList];

        setPermananentFeedBackList(
            permanentList.map((item, index) =>
                index === i ? { ...item, notesRemarks: value } : item
            )
        );
    };

    const checkTempArrHasValue = (tempList) => {
        // const tempList = [...tempFeedBackList];
        return tempList?.every((item, index) => {
            return item?.notesRemarks !== "";
        });
    };

    const selectRowForDelete = (e, i) => {
        const { checked } = e?.target;
        const feedback = [...permananentFeedBackList];
        feedback[i]["isSelect"] = checked ? 1 : 0;
        setPermananentFeedBackList(feedback);
    };

    const handlePrints = useReactToPrint({
        pageStyle: `@media print {
      @page {
       size: A4 portrait;
        margin: 2 !important;
         padding: 2 !important;
      }
body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  `,
        content: () => componentRef.current,
        onBeforeGetContent: () => { },
    });

    const clearSignature = () => {
        sigCanvas.current.clear();
        setSign(null);
    };

    const saveSignature = () => {
        if (sigCanvas.current.isEmpty()) {
            setSignError(true);
            return;
        }
        setSignError(false);
        setSign(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));

        // Close modal only if validation succeeds
        const modalElement = document.getElementById("signature-modal");
        if (modalElement) {
            const modalInstance =
                Modal.getInstance(modalElement) || new Modal(modalElement);
            modalInstance.hide();
        }
    };

    const handleFeedBack = () => {
        dispatch(staffRequestAction?.getReviewList(formID));
    };

    const addFeedback = (feedbackNo) => {
        if (
            crispFormDetailsResponse?.IsFormAcceptPdStaff === 0 &&
            crispFormDetailsResponse?.PdsFormOpenStatus === 1
        ) {
            return;
        }

        setClosePopup(false);
        setErrorMessage({});
        if (
            crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
            crispFormDetailsResponse?.PdsFormOpenStatus === 0
        ) {
            return;
        }
        const tempList = [...tempFeedBackList];

        const permanentList = [...permananentFeedBackList];

        const isRowexists = permananentFeedBackList?.some(
            (obj) => obj?.notesSNo === feedbackNo
        );

        const isNoteMarksEmpty = permananentFeedBackList?.some(
            (obj) => obj?.notesRemarks !== "" && obj?.notesSNo === feedbackNo
        );

        if (!isRowexists) {
            tempList?.push({ notesSNo: feedbackNo, notesRemarks: "", isSelect: 0 });
            permanentList?.push({
                notesSNo: feedbackNo,
                notesRemarks: "",
                isSelect: 0,
            });
        } else {
            if (isNoteMarksEmpty) {
                showToastNotification(
                    `${"S.no " + feedbackNo + " already Exist"}`,
                    "error"
                );
            }
            return;
        }
        setTempFeedBackList(tempList);
        setPermananentFeedBackList(permanentList);
    };

    const saveFeedBack = () => {
        //validation
        setErrorMessage({});
        const errorElements = document.querySelectorAll(".input-error");
        if (errorElements?.length > 0) {
            errorElements.forEach((element) =>
                element.classList.remove("input-error")
            );
        }

        const { error } = feedbackSchema({ feedback: permananentFeedBackList });
        if (error?.details) {
            error?.details?.map((e) => {
                const { path } = e;
                setErrorMessage((prev) => ({
                    ...prev,
                    [path[0] + "-" + path[1] + "-" + path[2]]: e?.message,
                }));

                const className = path[0] + "-" + path[1] + "-" + path[2];
                const element = document.querySelector(`[name=${className}]`);
                element?.classList?.add("input-error", className);
            });
            return;
        }
        //update temp list for revert use
        const permanenetList = [...permananentFeedBackList];
        //clear check box when save

        const arrWithClearCheckBoxValue = permanenetList?.map((item) => {
            return { ...item, isSelect: 0 };
        });
        setStoredValue(
            "feedbackList",
            arrWithClearCheckBoxValue
        );
        setTempFeedBackList(arrWithClearCheckBoxValue);
        setPermananentFeedBackList(arrWithClearCheckBoxValue);
        showToastNotification("Saved Successfully", "success");
        setClosePopup(true);
    };

    const handleFeedBackBlur = () => {
        setErrorMessage({});
        const errorElements = document.querySelectorAll(".input-error");
        if (errorElements?.length > 0) {
            errorElements.forEach((element) =>
                element.classList.remove("input-error")
            );
        }

        const { error } = feedbackSchema({ feedback: permananentFeedBackList });
        if (error?.details) {
            error?.details?.map((e) => {
                const { path } = e;
                setErrorMessage((prev) => ({
                    ...prev,
                    [path[0] + "-" + path[1] + "-" + path[2]]: e?.message,
                }));

                const className = path[0] + "-" + path[1] + "-" + path[2];
                const element = document.querySelector(`[name=${className}]`);
                element?.classList?.add("input-error", className);
            });
            return;
        }
    };

    const deleteFeedBack = () => {
        const list = [...permananentFeedBackList];
        const isCheckBoxSelect = list?.some((item) => item?.isSelect === 1);
        if (!isCheckBoxSelect) {
            showToastNotification("Please Select Row To Delete", "warning");
            return;
        }

        const removeList = list?.filter((item, index) => item?.isSelect === 0);
        setPermananentFeedBackList(removeList);
        setTempFeedBackList(removeList);
        setStoredValue("feedbackList", removeList);
        setClosePopup(true);
    };

    const handleCloseModal = () => {
        const tempList = [...tempFeedBackList];
        setPermananentFeedBackList(tempList);

        // const setEmptyNotesMarks = tempList?.map((item, index) => {
        //   return { ...item, notesRemarks: "" };
        // });
        // setTempFeedBackList(setEmptyNotesMarks);
    };

    // const closePopup = () => {
    //   const modalElement = document.getElementById("public-defender-crisp-correction-modal");
    //   const modalInstance = bootstrap.Modal.getInstance(modalElement);

    //   if (modalInstance) {
    //     modalInstance.hide();
    //   }
    // };

    const startProcessing = () => {
        Popup({
            title: "Message",
            text: `Other public defender staff will not be able to work on this form until you reject it. Do you wish to proceed?`,
            icon: "info",
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            onConfirm: () => {
                setPDStaffAssignAccept(1);
                dispatch(
                    staffRequestAction?.startProcessing({
                        requestForumThreadID: formID,
                        facilityID: facilityCode,
                        managementUserID: loggedUser,
                        pdStaffAssignAccept: 1,
                        pdStaffAssignReject: 0,
                    })
                );
            },
        });
    };

    const handleReject = () => {
        Popup({
            title: "Message",
            text: `By rejecting the form, other public defender staffs will work on this form. Do you wish to proceed?`,
            icon: "info",
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            onConfirm: () => {
                setPDStaffAssignAccept(0);
                dispatch(
                    staffRequestAction?.startProcessing({
                        requestForumThreadID: formID,
                        facilityID: facilityCode,
                        managementUserID: loggedUser,
                        pdStaffAssignAccept: 0,
                        pdStaffAssignReject: 1,
                    })
                )
                    .then((result) => {
                        if (result?.payload) {
                            const searchData = { ...staffRequestDefenderSearchList };
                            searchData.FacilityID = facilityCode;
                            searchData.ManagementUserID = managementUserID;
                            searchData.ActiveStatus =
                                searchData.ActiveStatus === 3 ? 2 : searchData.ActiveStatus;
                            searchData.PageNo = 1;
                            searchData.RowCountPerPage = publicDefenderList?.TotalRecordCount;
                            dispatch(
                                staffRequestAction?.PublicDefenderRequestReviewList(searchData)
                            ).then((result) => {
                                if (result?.payload?.DataList?.length > 0) {
                                    const data = result?.payload;
                                    handleReviewRequestFormNavigation(
                                        "next",
                                        data,
                                        indexValue,
                                        history,
                                        sourceFrom,
                                        dispatch
                                    );
                                } else {
                                    history?.navigate("/Admin/StaffRequestList");
                                }
                            });

                            if (requestReview) {
                                setIsShowStartProcessingBtn(true);
                                setIsShowApprovedBtn(false);
                                setIsShowRejectBtn(false);
                                setIsShowResubmitBtn(false);
                                setRequestFormSubmitted(false);
                            }

                            // setRequestFormSubmitted(true);
                        }
                    })
                    .catch((err) => {
                        showToastNotification("Failed to reject form", "error");
                    });
            },
        });
    };

    const handleResubmit = () => {
        const isNotesMarksEmpty = tempFeedBackList?.every(
            (item, index) => item?.notesRemarks === ""
        );
        if (isNotesMarksEmpty) {
            showToastNotification("Notes is empty");
            return;
        }
        const payload = {
            typ_RequestPdsNotesDetails: tempFeedBackList,
            requestPublicDefenderServicesID:
                crispFormDetailsResponse?.RequestPublicDefenderServicesID,
            facilityID: facilityCode,
            publicDefenderStaffID: managementUserID,
            pdStaffFormReSubmit: 1,
            pdStaffApproveForm: 0,
            witnessSignature: sign,
            InmateId: crispFormDetailsResponse?.InmateID
        };

        dispatch(staffRequestAction?.handleSubmit(payload))
            .then((result) => {
                const response = result?.payload?.IsSucceed;
                if (response > 0) {
                    showToastNotification("Resubmitted Successfully", "success");

                    const searchData = { ...staffRequestDefenderSearchList };
                    searchData.FacilityID = facilityCode;
                    searchData.ManagementUserID = managementUserID;
                    searchData.ActiveStatus =
                        searchData.ActiveStatus === 3 ? 2 : searchData.ActiveStatus;
                    searchData.PageNo = 1;
                    searchData.RowCountPerPage = publicDefenderList?.TotalRecordCount;
                    dispatch(
                        staffRequestAction?.PublicDefenderRequestReviewList(searchData)
                    ).then((result) => {
                        if (result?.payload?.DataList?.length > 0) {
                            const data = result?.payload;
                            handleReviewRequestFormNavigation(
                                "next",
                                data,
                                indexValue,
                                history,
                                sourceFrom,
                                dispatch
                            );
                        } else {
                            history?.navigate("/Admin/StaffRequestList");
                        }
                    });

                    setRequestFormSubmitted(false);
                    // setRequestFormSubmitted(true);
                    const formList = [...submittedFormList];
                    formList.push(formID);
                    setSubmittedFormList(formList);
                    if (!requestReview) {
                        history?.navigate("StaffRequestList");
                    }
                }
            })
            .catch((err) => {
                showToastNotification("Error in save please try again");
            });
    };

    const handleApprove = () => {
        const payload = {
            typ_RequestPdsNotesDetails: tempFeedBackList,
            requestPublicDefenderServicesID:
                crispFormDetailsResponse?.RequestPublicDefenderServicesID,
            facilityID: facilityCode,
            publicDefenderStaffID: managementUserID,
            pdStaffFormReSubmit: 0,
            pdStaffApproveForm: 1,
            witnessSignature: sign,
            InmateId: crispFormDetailsResponse?.InmateID
        };
        dispatch(staffRequestAction?.handleSubmit(payload))
            .then((result) => {
                const response = result?.payload?.IsSucceed;
                if (response > 0) {
                    const searchData = { ...staffRequestDefenderSearchList };
                    searchData.FacilityID = facilityCode;
                    searchData.ManagementUserID = managementUserID;
                    searchData.ActiveStatus =
                        searchData.ActiveStatus === 3 ? 2 : searchData.ActiveStatus;
                    searchData.PageNo = 1;
                    searchData.RowCountPerPage = publicDefenderList?.TotalRecordCount;
                    dispatch(
                        staffRequestAction?.PublicDefenderRequestReviewList(searchData)
                    )
                        .then((result) => {
                            if (result?.payload?.DataList?.length > 0) {
                                const data = result?.payload;
                                handleReviewRequestFormNavigation(
                                    "next",
                                    data,
                                    indexValue,
                                    history,
                                    sourceFrom,
                                    dispatch
                                );
                            } else {
                                history?.navigate("/Admin/StaffRequestList");
                            }
                        })
                        .catch((err) => {
                            showToastNotification("Failed to get form list", "error");
                        });
                    if (!requestReview) {
                        history?.navigate("StaffRequestList");
                    }
                    showToastNotification("Approved Successfully", "success");
                }
            })
            .catch((err) => {
                if (!requestReview) {
                    history?.navigate("StaffRequestList");
                }
                showToastNotification("Failed in Approve form", "error");
            });
    };

    if (loading) return <CustomLoader />;

    return (
        <div className="card position-relative overflow-auto shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100">
            <DefenderFormHeader
                list={formDetails}
                requestReview={requestReview}
                handlePrints={handlePrints}
                showFeedBack={crispFormDetailsResponse?.IsPdsServicesNotesExists === 1}
                handleFeedBack={handleFeedBack}
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
                requestFormSubmitted={requestFormSubmitted}
                setRequestFormSubmitted={setRequestFormSubmitted}
                reviewList
            />

            <div className="newrequest-form-pdf">
                <div className="">
                    <form>
                        {/* <div className="innerContent" ref={componentRef}> */}
                        <div className="">
                            <article>
                                <div ref={componentRef}>
                                    <div className="row d-flex  align-items-center mb-3">
                                        <div className="col-md-3">
                                            <img
                                                src={PublicDefenderLogo}
                                                alt="facility-logo"
                                                style={{ height: "60px", width: "130px" }}
                                            />
                                        </div>
                                        <h3 className="text-color py-2 col-md-9">
                                            APPLICATION FOR PUBLIC DEFENDER SERVICES
                                        </h3>
                                    </div>

                                    <div>
                                        <div className="col-sub-three">
                                            <div
                                                className="mb-1 crisp-label-style d-flex "
                                                onClick={() => addFeedback(1)}
                                            >
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    1
                                                </span>
                                                <span className="crisp-label-style">
                                                    Application Date :
                                                </span>
                                            </div>
                                            <span className="fw-bold value-items ">
                                                {crispFormDetailsResponse?.ApplicationData}
                                            </span>
                                        </div>
                                        <div
                                            className="col-sub-three"
                                            onClick={() => addFeedback(2)}
                                        >
                                            <div className="fs-5 mb-0 d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    2
                                                </span>
                                                <span className="crisp-label-style">County :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.FacilityName
                                                    ? crispFormDetailsResponse?.FacilityName
                                                    : "-"}
                                            </span>
                                        </div>
                                        <div
                                            className="col-sub-three"
                                            onClick={() => addFeedback(3)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    3
                                                </span>
                                                <span className="crisp-label-style"> Last Name :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.LastName}
                                            </span>
                                        </div>

                                    </div>



                                    <div className="">

                                        <div
                                            className="col-sub-three"
                                        >
                                            <div className="fs-5 mb-0  d-flex headervalue-items">
                                                <span className="crisp-label-style"> First Name :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.FirstName}
                                            </span>
                                        </div>
                                        <div
                                            className="col-sub-three"
                                        >
                                            <div className="fs-5 mb-0  d-flex headervalue-items">
                                                <span className="crisp-label-style"> Middle Name :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.MiddleName || "-"}
                                            </span>
                                        </div>

                                        <div
                                            className="col-sub-three"
                                            onClick={() => addFeedback(4)}
                                        >
                                            <div className="fs-5 mb-0  d-flex  crisp-form-highlight-txt">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    4
                                                </span>
                                                CHARGES :
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.Charges}
                                            </span>
                                        </div>

                                    </div>





                                    <div className="">

                                        <div
                                            className="col-sub-two"
                                            onClick={() => addFeedback(5)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    5
                                                </span>
                                                <span className="crisp-label-style"> Address :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.InmateAddress}
                                            </span>
                                        </div>
                                        <div
                                            className="col-sub-two"
                                            onClick={() => addFeedback(6)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    6
                                                </span>
                                                <span className="crisp-label-style"> City :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.City}
                                            </span>
                                        </div>

                                        <div
                                            className="col-sub-two"
                                            onClick={() => addFeedback(7)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    7
                                                </span>
                                                <span className="crisp-label-style"> State :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {stateName?.[0]?.label}
                                            </span>
                                        </div>

                                        <div
                                            className="col-sub-three"
                                            onClick={() => addFeedback(8)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    8
                                                </span>
                                                <span className="crisp-label-style"> ZIP :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.Zip}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="">
                                        <h4
                                            className="inner-header-bg text-color mt-2"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <i className="fa-solid fa-phone me-2"></i> Telephone No(s)
                                            :
                                        </h4>
                                        <div
                                            className="col-sub-three"
                                            onClick={() => addFeedback(9)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    9
                                                </span>
                                                <span className="crisp-label-style"> Home :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.HomePhone}
                                            </span>
                                        </div>

                                        <div
                                            className="col-sub-three"
                                            onClick={() => addFeedback(10)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    10
                                                </span>
                                                <span className="crisp-label-style"> Cell :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.CellPhone}
                                            </span>
                                        </div>

                                        <div
                                            className="col-sub-three"
                                            onClick={() => addFeedback(11)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    11
                                                </span>
                                                <span className="crisp-label-style">Work :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.WorkPhone}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div
                                            className="col-sub-three"
                                            onClick={() => addFeedback(12)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    12
                                                </span>
                                                <span className="crisp-label-style"> DOB : </span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.DOB}
                                            </span>
                                        </div>

                                        <div
                                            className="col-sub-three"
                                            onClick={() => addFeedback(13)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    13
                                                </span>
                                                <span className="crisp-label-style">
                                                    {" "}
                                                    Social Security Number :{" "}
                                                </span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.SSN}
                                            </span>
                                        </div>

                                        <div
                                            className="col-sub-three"
                                            onClick={() => addFeedback(14)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    14
                                                </span>
                                                <span className="crisp-label-style"> Race : </span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.Race}
                                            </span>
                                        </div>

                                        <div
                                            className="col-sub-two"
                                            onClick={() => addFeedback(15)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    15
                                                </span>
                                                <span className="crisp-label-style"> Sex : </span>
                                            </div>
                                            <div className="d-flex mt-2 gap-2">
                                                <div className="d-flex  gap-2">
                                                    <input
                                                        type="radio"
                                                        name="gender"
                                                        className="form-check-input"
                                                        value={"1"}
                                                        checked={crispFormDetailsResponse?.Gender === "1"}
                                                        disabled
                                                        readOnly
                                                    />
                                                    <label className="form-check-label fs-5">Male</label>
                                                </div>

                                                <div className="d-flex  gap-2">
                                                    <input
                                                        type="radio"
                                                        name="gender"
                                                        className="form-check-input"
                                                        value={"2"}
                                                        checked={crispFormDetailsResponse?.Gender === "2"}
                                                        disabled
                                                        readOnly
                                                    />
                                                    <label className="form-check-label fs-5">
                                                        Female
                                                    </label>
                                                </div>

                                                <div className="d-flex  gap-2">
                                                    <input
                                                        type="radio"
                                                        name="gender"
                                                        className="form-check-input"
                                                        value={"3"}
                                                        checked={crispFormDetailsResponse?.Gender === "3"}
                                                        disabled
                                                        readOnly
                                                    />
                                                    <label className="form-check-label fs-5">
                                                        Unknown
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="col-sub-two"
                                            onClick={() => addFeedback(16)}
                                        >
                                            <div className="fs-5 mb-0  d-flex  w-100">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    16
                                                </span>
                                                <span className="crisp-label-style">
                                                    The person who can always reach you :
                                                </span>
                                            </div>
                                            <div className="col-md-12">
                                                <span className="crisp-label-style label-items">
                                                    {" "}
                                                    Name :
                                                </span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.EmergContactPerson}
                                            </span>
                                        </div>



                                        <div
                                            className="col-sub-two"
                                            onClick={() => addFeedback(17)}
                                        >
                                            <div className="fs-5 mb-0  d-flex  w-100">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    17
                                                </span>
                                                <span className="crisp-label-style"> Telephone : </span>
                                            </div>
                                            <div className="col-md-12"></div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.EmergContactPhone}
                                            </span>
                                        </div>

                                        <div
                                            className="col-sub-two"
                                            onClick={() => addFeedback(18)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    18
                                                </span>
                                                <span className="crisp-label-style"> Address </span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.EmergContactAddress}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="col-sub-two" onClick={() => addFeedback(19)}>
                                        <div className="fs-5 mb-0  d-flex  crisp-form-highlight-txt">
                                            <span
                                                {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                    1 && crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? {
                                                        "data-bs-toggle": "modal",
                                                        "data-bs-target":
                                                            "#public-defender-crisp-correction-modal",
                                                    }
                                                    : "")}
                                                className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                                                    crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? "animate-opacity"
                                                    : ""
                                                    }`}
                                            >
                                                19
                                            </span>
                                            <span> MARITAL STATUS :</span>
                                        </div>
                                        <div className="d-flex  mt-2 flex-column gap-2">
                                            <div className="d-flex  gap-2">
                                                <input
                                                    type="radio"
                                                    name="MaritalStatus"
                                                    className="form-check-input"
                                                    value={1}
                                                    checked={
                                                        crispFormDetailsResponse?.MaritalStatus === 1
                                                    }
                                                    disabled
                                                    readOnly
                                                />
                                                <label className="form-check-label fs-5">Single</label>
                                            </div>

                                            <div className="d-flex  gap-2">
                                                <input
                                                    type="radio"
                                                    name="MaritalStatus"
                                                    className="form-check-input"
                                                    value={2}
                                                    checked={
                                                        crispFormDetailsResponse?.MaritalStatus === 2
                                                    }
                                                    disabled
                                                    readOnly
                                                />
                                                <label className="form-check-label fs-5">
                                                    Divorced
                                                </label>
                                            </div>

                                            <div className="d-flex  gap-2">
                                                <input
                                                    type="radio"
                                                    name="MaritalStatus"
                                                    className="form-check-input"
                                                    value={3}
                                                    checked={
                                                        crispFormDetailsResponse?.MaritalStatus === 3
                                                    }
                                                    disabled
                                                    readOnly
                                                />
                                                <label className="form-check-label fs-5">
                                                    Separated
                                                </label>
                                            </div>

                                            <div className="d-flex  gap-2">
                                                <input
                                                    type="radio"
                                                    name="MaritalStatus"
                                                    className="form-check-input"
                                                    value={4}
                                                    checked={
                                                        crispFormDetailsResponse?.MaritalStatus === 4
                                                    }
                                                    disabled
                                                    readOnly
                                                />
                                                <label className="form-check-label fs-5">Married</label>
                                            </div>

                                            <div className="d-flex  gap-2">
                                                <input
                                                    type="radio"
                                                    name="MaritalStatus"
                                                    className="form-check-input"
                                                    value={5}
                                                    checked={
                                                        crispFormDetailsResponse?.MaritalStatus === 5
                                                    }
                                                    disabled
                                                    readOnly
                                                />
                                                <label className="form-check-label fs-5">
                                                    Living with the parent of your children
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sub-two" onClick={() => addFeedback(20)}>
                                        <div className="fs-5 mb-0  d-flex ">
                                            <span
                                                {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                    1 && crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? {
                                                        "data-bs-toggle": "modal",
                                                        "data-bs-target":
                                                            "#public-defender-crisp-correction-modal",
                                                    }
                                                    : "")}
                                                className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                                                    crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? "animate-opacity"
                                                    : ""
                                                    }`}
                                            >
                                                20
                                            </span>
                                            <span className="crisp-label-style">
                                                {" "}
                                                Spouse’s Name :{" "}
                                            </span>
                                        </div>
                                        {crispFormDetailsResponse?.MaritalStatus !== 1 && (
                                            <span className="fw-bold value-items ">
                                                {crispFormDetailsResponse?.SpousesName}
                                            </span>
                                        )}
                                    </div>

                                    <h4
                                        className="inner-header-bg text-color mt-2"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <i className="fa-solid fa-briefcase me-2"></i> EMPLOYMENT :
                                    </h4>
                                    <div className="row">
                                        <div
                                            className="col-sub-one"
                                            onClick={() => addFeedback(21)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    21
                                                </span>
                                                <span className="crisp-label-style">
                                                    {" "}
                                                    Are you employed (including self-employment, part-time
                                                    work, or “odd jobs”)?{" "}
                                                </span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                <div className="d-flex  gap-2">
                                                    <div className="d-flex  gap-2">
                                                        <input
                                                            type="radio"
                                                            name="IsInmateEmployed"
                                                            className="form-check-input"
                                                            value={1}
                                                            checked={
                                                                crispFormDetailsResponse?.IsInmateEmployed === 1
                                                            }
                                                            disabled
                                                            readOnly
                                                        />
                                                        <label className="form-check-label fs-5">Yes</label>
                                                    </div>
                                                    <div className="d-flex  gap-2">
                                                        <input
                                                            type="radio"
                                                            name="IsInmateEmployed"
                                                            className="form-check-input"
                                                            value={0}
                                                            checked={
                                                                crispFormDetailsResponse?.IsInmateEmployed === 0
                                                            }
                                                            disabled
                                                            readOnly
                                                        />
                                                        <label className="form-check-label fs-5">No</label>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div
                                            className="col-sub-one"
                                            onClick={() => addFeedback(22)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    22
                                                </span>
                                                <span className="crisp-label-style">
                                                    If yes, employer name, address, telephone number :
                                                </span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.IsInmateEmployed === 1 &&
                                                    crispFormDetailsResponse?.EmployerDetails}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div
                                            className="col-sub-two"
                                            onClick={() => addFeedback(23)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    23
                                                </span>
                                                <span className="crisp-label-style"> Job title :</span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.IsInmateEmployed === 1
                                                    ? crispFormDetailsResponse?.JobTitle
                                                    : ""}
                                            </span>
                                        </div>

                                        <div className="col-sub-two">
                                            <div
                                                className="fs-5 mb-0  d-flex "
                                                onClick={() => addFeedback(24)}
                                            >

                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    24
                                                </span>
                                                <span className="crisp-label-style">
                                                    {" "}
                                                    Length of employment{" "}
                                                </span>
                                            </div>
                                            <span className="fw-bold value-items">
                                                {crispFormDetailsResponse?.IsInmateEmployed === 1
                                                    ? crispFormDetailsResponse?.LengthEmployment +
                                                    " Year(s)"
                                                    : 0 + " Year(s)"}
                                            </span>
                                        </div>
                                    </div>

                                    <h4
                                        className="inner-header-bg text-color mt-2"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <i className="fa-solid fa-dollar-sign me-2"></i> INCOME :
                                    </h4>
                                    <div className="">
                                        <div
                                            className="col-sub-one"
                                            onClick={() => addFeedback(25)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    25
                                                </span>
                                                <span className="crisp-label-style">
                                                    {" "}
                                                    Net income (total income, minus deductions required by
                                                    law and child support payments deducted from paycheck)
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-sub-one-third">
                                            <span className="fw-bold value-items">
                                                {"$ " +
                                                    parseFloat(
                                                        crispFormDetailsResponse?.InmateNetIncome
                                                    ).toFixed(2)}
                                            </span>
                                        </div>
                                        {/* {parseInt(crispFormDetailsResponse?.InmateNetIncome)} */}
                                        <div className="col-sub-two-third">
                                            <div className="d-flex  p-1">
                                                <div className="d-flex  gap-2">
                                                    <div className="d-flex  gap-2">
                                                        <input
                                                            type="radio"
                                                            name="InmateIncomeCycle"
                                                            className="form-check-input"
                                                            value={1}
                                                            checked={
                                                                crispFormDetailsResponse &&
                                                                crispFormDetailsResponse?.InmateNetIncome !==
                                                                "" &&
                                                                crispFormDetailsResponse?.InmateNetIncome?.toString() !==
                                                                "" &&
                                                                crispFormDetailsResponse?.InmateIncomeCycle ===
                                                                1
                                                            }
                                                            disabled
                                                            readOnly
                                                        />
                                                        <label className="form-check-label fs-5">
                                                            Week
                                                        </label>
                                                    </div>

                                                    <div className="d-flex  gap-2">
                                                        <input
                                                            type="radio"
                                                            name="InmateIncomeCycle"
                                                            className="form-check-input"
                                                            value={2}
                                                            checked={
                                                                // crispFormDetailsResponse?.InmateNetIncome !==
                                                                //   0 &&
                                                                crispFormDetailsResponse &&
                                                                crispFormDetailsResponse?.InmateNetIncome !==
                                                                "" &&
                                                                crispFormDetailsResponse?.InmateNetIncome?.toString() !==
                                                                "" &&
                                                                crispFormDetailsResponse?.InmateIncomeCycle ===
                                                                2
                                                            }
                                                            disabled
                                                            readOnly
                                                        />
                                                        <label className="form-check-label fs-5">
                                                            Two Weeks
                                                        </label>
                                                    </div>

                                                    <div className="d-flex  gap-2">
                                                        <input
                                                            type="radio"
                                                            name="InmateIncomeCycle"
                                                            className="form-check-input"
                                                            value={3}
                                                            checked={
                                                                // crispFormDetailsResponse?.InmateNetIncome !==
                                                                //   0 &&
                                                                crispFormDetailsResponse &&
                                                                crispFormDetailsResponse?.InmateNetIncome !==
                                                                "" &&
                                                                crispFormDetailsResponse?.InmateNetIncome?.toString() !==
                                                                "" &&
                                                                crispFormDetailsResponse?.InmateIncomeCycle ===
                                                                3
                                                            }
                                                            disabled
                                                            readOnly
                                                        />
                                                        <label className="form-check-label fs-5">
                                                            Month
                                                        </label>
                                                    </div>

                                                    <div className="d-flex  gap-2">
                                                        <input
                                                            type="radio"
                                                            name="InmateIncomeCycle"
                                                            className="form-check-input"
                                                            value={4}
                                                            checked={
                                                                // crispFormDetailsResponse?.InmateNetIncome !==
                                                                //   0 &&
                                                                crispFormDetailsResponse &&
                                                                crispFormDetailsResponse?.InmateNetIncome !==
                                                                "" &&
                                                                crispFormDetailsResponse?.InmateNetIncome?.toString() !==
                                                                "" &&
                                                                crispFormDetailsResponse?.InmateIncomeCycle ===
                                                                4
                                                            }
                                                            disabled
                                                            readOnly
                                                        />
                                                        <label className="form-check-label fs-5">
                                                            Year
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="">
                                        <div
                                            className="col-sub-one"
                                            onClick={() => addFeedback(26)}
                                        >
                                            <div className="fs-5 mb-0  d-flex flex-wrap">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    26
                                                </span>
                                                <span className="crisp-label-style">
                                                    {" "}
                                                    If incarcerated, do you have income while in jail?{" "}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div className="col-sub-two">
                                            <div className="d-flex flex-wrap gap-2">
                                                <div className="d-flex flex-wrap gap-2">
                                                    <input
                                                        type="radio"
                                                        name="IsJailIncome"
                                                        className="form-check-input"
                                                        value={1}
                                                        checked={
                                                            crispFormDetailsResponse?.IsJailIncome === 1
                                                        }
                                                        disabled
                                                        readOnly
                                                    />
                                                    <label className="form-check-label fs-5">Yes</label>
                                                </div>

                                                <div className="d-flex flex-wrap gap-2">
                                                    <input
                                                        type="radio"
                                                        name="IsJailIncome"
                                                        className="form-check-input"
                                                        value={"3"}
                                                        checked={
                                                            crispFormDetailsResponse?.IsJailIncome === 0
                                                        }
                                                        disabled
                                                        readOnly
                                                    />
                                                    <label className="form-check-label fs-5">No</label>
                                                </div>
                                            </div>
                                        </div>
                                        {crispFormDetailsResponse?.IsJailIncome === 1 && (
                                            <div className="col-sub-two">
                                                <div className="col-md-6  d-flex  flex-wrap border-0">
                                                    <span className="crisp-label-style"> Amount: $ </span>
                                                </div>
                                                <div className="col-md-6  p-1">
                                                    <span className="fw-bold crisp-border">
                                                        {"$ " +
                                                            crispFormDetailsResponse?.JailIncome?.toFixed(2)}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>



                                    <div className="">
                                        <div
                                            className="col-sub-one"
                                            onClick={() => addFeedback(27)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    27
                                                </span>
                                                <span className="crisp-label-style">
                                                    {" "}
                                                    Do you receive: Military, VA, Social Security, SSI,
                                                    TANF, Food Stamps, or Retirement benefits?{" "}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div className="col-sub-two">
                                            <div className="col-md-6  d-flex  p-1">
                                                <div className="d-flex  gap-2">
                                                    <div className="d-flex  gap-2">
                                                        <input
                                                            type="radio"
                                                            name="IsReceiveOtherBenefits"
                                                            className="form-check-input"
                                                            value={1}
                                                            checked={
                                                                crispFormDetailsResponse?.IsReceiveOtherBenefits ===
                                                                1
                                                            }
                                                            disabled
                                                            readOnly
                                                        />
                                                        <label className="form-check-label fs-5">Yes</label>
                                                    </div>

                                                    <div className="d-flex  gap-2">
                                                        <input
                                                            type="radio"
                                                            name="IsReceiveOtherBenefits"
                                                            className="form-check-input"
                                                            value={0}
                                                            checked={
                                                                crispFormDetailsResponse?.IsReceiveOtherBenefits ===
                                                                0
                                                            }
                                                            disabled
                                                            readOnly
                                                        />
                                                        <label className="form-check-label fs-5">No</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sub-two">
                                            <span className="crisp-label-style"> Amount: $ </span>
                                            <div className="col-md-6 p-1">
                                                {crispFormDetailsResponse?.IsReceiveOtherBenefits ===
                                                    1 && (
                                                        <span className="fw-bold crisp-border ">
                                                            {crispFormDetailsResponse?.OtherBenefitsAmount?.toFixed(
                                                                2
                                                            )}
                                                        </span>
                                                    )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div
                                            className="col-sub-two"
                                            onClick={() => addFeedback(28)}
                                        >
                                            <div className="fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    28
                                                </span>
                                                <span className="crisp-label-style">
                                                    {" "}
                                                    Are you disabled?{" "}
                                                </span>
                                            </div>
                                            <div className="col-md-6  d-flex mt-1 p-1">
                                                <div className="d-flex  gap-2">
                                                    <div className="d-flex  gap-2">
                                                        <input
                                                            type="radio"
                                                            name="IsInmateDisabled"
                                                            className="form-check-input"
                                                            value={1}
                                                            checked={
                                                                crispFormDetailsResponse?.IsInmateDisabled === 1
                                                            }
                                                            disabled
                                                            readOnly
                                                        />
                                                        <label className="form-check-label fs-5">Yes</label>
                                                    </div>

                                                    <div className="d-flex  gap-2">
                                                        <input
                                                            type="radio"
                                                            name="IsInmateDisabled"
                                                            className="form-check-input"
                                                            value={0}
                                                            checked={
                                                                crispFormDetailsResponse?.IsInmateDisabled === 0
                                                            }
                                                            disabled
                                                            readOnly
                                                        />
                                                        <label className="form-check-label fs-5">No</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sub-two">
                                            <span className="crisp-label-style">
                                                If Yes, what type of Disability
                                            </span>
                                            <br />
                                            {crispFormDetailsResponse?.IsInmateDisabled === 1 && (
                                                <span className="fw-bold crisp-border ">
                                                    {crispFormDetailsResponse?.TypeOfDisability}
                                                </span>
                                            )}
                                        </div>
                                    </div>


                                    <div className="border">
                                        <div
                                            className="col-sub-one d-flex flex-wrap"
                                            onClick={() => addFeedback(29)}
                                        >
                                            <span
                                                {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                    1 && crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? {
                                                        "data-bs-toggle": "modal",
                                                        "data-bs-target":
                                                            "#public-defender-crisp-correction-modal",
                                                    }
                                                    : "")}
                                                className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                                                    crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? "animate-opacity"
                                                    : ""
                                                    }`}
                                            >
                                                29
                                            </span>
                                            <span className="crisp-label-style">
                                                If you
                                                <span className="crisp-form-highlight-txt ">
                                                    {" "}
                                                    DO NOT{" "}
                                                </span>
                                                desire the services of court appointed counsel, please
                                                sign and date here :
                                            </span>
                                        </div>

                                        <div className="d-flex">
                                            <div className="col-sub-two">
                                                <div className=" fs-5 mb-0  d-flex ">
                                                    <span className="crisp-label-style">
                                                        {" "}
                                                        Signature :{" "}
                                                    </span>
                                                </div>

                                                {crispFormDetailsResponse?.NotDesireServicesSign && (
                                                    <div className="fw-bold value-items">
                                                        <img
                                                            height={"60px"}
                                                            width={"210px"}
                                                            src={
                                                                crispFormDetailsResponse?.NotDesireServicesSign
                                                            }
                                                            alt="NotDesireServicesSign"
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            <div className="col-sub-two">
                                                <div className=" fs-5 mb-0  d-flex ">
                                                    <span className="crisp-label-style"> Date : </span>
                                                </div>
                                                <div className="fw-bold crisp-border">
                                                    {crispFormDetailsResponse?.NotDesireServicesDate}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <h4
                                        className="inner-header-bg text-color mt-2"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <i className="fa-solid fa-receipt me-2 fw-bold"></i> NOTICE OF
                                        APPLICATION FEE AND ATTORNEY FEE:
                                    </h4>
                                    <p className="crisp-label-style fw-bold text-crisp-form-align">
                                        Georgia law requires every person who applies for legal
                                        defense services under Chapter 12 of Title 17 to pay the
                                        Public Defender Office (the entity providing the services) a
                                        single fee of $50 for the application for, receipt of, or
                                        application for and receipt of such services (O.C.G.A.
                                        Section 15-21A 6(b). However, this application fee may not
                                        be imposed if the payment of the fee is waived by the court
                                        in which you are appearing. The court shall waive this fee
                                        if it finds that you are unable to pay the fee or that
                                        hardship will result if the fee is charged. (O.C.G.A.
                                        Section 15-21A 6(b). Attorney fees for court- appointed
                                        representation may also be imposed by the court at
                                        sentencing.
                                    </p>
                                    <h4
                                        className="inner-header-bg text-color mt-2"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <i className="fa-solid fa-check-circle me-2 fw-bold"></i>{" "}
                                        VERIFICATION AND RELEASE:
                                    </h4>
                                    <p className="crisp-label-style fw-bold text-crisp-form-align">
                                        BY MY SIGNATURE BELOW, I SWEAR UNDER PENALTY OF PERJURY THAT
                                        THE INFORMATION CONTAINED HEREIN IS TRUE AND BASED UPON MY
                                        PERSONAL KNOWLEDGE, AND I REQUEST THAT THE CIRCUIT PUBLIC
                                        DEFENDER’S OFFICE (CPD) REPRESENT ME, OR THE MINOR CHILD OR
                                        TAX-DEPENDENT PERSON I AM PARENT OR GUARDIAN OF, IN THE
                                        ABOVE STYLED CASE(S). FURTHER, I AGREE TO IMMEDIATELY REPORT
                                        ANY CHANGE IN MY FINANCIAL SITUATION TO THE CPD OR TO THE
                                        COURT. I HEREBY AUTHORIZE ANY PERSON OR AGENCY REQUESTED BY
                                        THE CPD OR ANY OF ITS EMPLOYEES TO RELEASE TO THE CPD ANY
                                        INFORMATION REQUESTED TO ASSIST IN CONSIDERATION OF MY
                                        APPLICATION. INFORMATION MAY INCLUDE INFORMATION ABOUT
                                        HOUSEHOLD INCOME, EMPLOYMENT, EXPENSES, LIABILITIES, OR
                                        OTHER INFORMATION REQUESTED TO ASSESS THE APPLICATION. I
                                        ALSO VERIFY THAT I HAVE READ THE NOTICE OF APPLICATION FEE.
                                        I UNDERSTAND THAT IF I HAVE MADE ANY FALSE STATEMENTS THAT I
                                        MAY BE CHARGED WITH A FELONY WHICH CARRIES A PENALTY OF FROM
                                        ONE TO FIVE YEARS to wit: § 16-10-20. False statements and
                                        writings; concealment of facts: A person who knowingly and
                                        willfully falsifies, conceals, or covers up by any trick,
                                        scheme, or device a material fact; makes a false,
                                        fictitious, or fraudulent statement or representation; or
                                        makes or uses any false writing or document, knowing the
                                        same to contain any false, fictitious, or fraudulent
                                        statement or entry, in any matter within the jurisdiction of
                                        any department or agency of state government or of the
                                        government of any county, city, or other political
                                        subdivision of this state shall, upon conviction thereof, be
                                        punished by a fine of not more than $1,000.00 or by
                                        imprisonment for not less than one nor more than five years,
                                        or both.
                                    </p>

                                    <div className="d-flex fw-bold mt-3 col-sub-one" onClick={() => addFeedback(30)}>
                                        <span
                                            {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                1 && crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                ? {
                                                    "data-bs-toggle": "modal",
                                                    "data-bs-target":
                                                        "#public-defender-crisp-correction-modal",
                                                }
                                                : "")}
                                            className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                                                crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                ? "animate-opacity"
                                                : ""
                                                }`}
                                        >
                                            30
                                        </span>
                                        <span className="crisp-label-style fw-bold">
                                            This Application is for{" "}
                                            <TextInput
                                                cName={""}
                                                name="ApplicationCaseDetails"
                                                value={crispFormDetailsResponse?.ApplicationCaseDetails}
                                                disabled
                                                readonly
                                            />
                                            case(s). I understand that I will be assessed an
                                            application fee and any applicable attorney fees for each
                                            case.
                                        </span>
                                    </div>
                                    <div className="mt-3 fw-bold col-sub-one">
                                        <CheckBoxInput
                                            label={
                                                "I HEREBY SWEAR OR AFFIRM THAT ALL OF THE ABOVE INFORMATION IS TRUE AND CORRECT TO THE BEST OF MY KNOWLEDGE."
                                            }
                                            checked
                                            disabled
                                            readOnly
                                        />
                                    </div>
                                    <div className="clearfix"></div>


                                    <div className="d-flex  mt-3">
                                        <div
                                            className="col-sub-two "
                                            onClick={() => addFeedback(31)}
                                        >
                                            <div className=" fs-5 mb-0  d-flex  ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    31
                                                </span>
                                                {/* This 30 th day of Jan , 20 25 . */}
                                                <span className="crisp-label-style">
                                                    {" "}
                                                    {`This ${day} day of ${monthList[month - 1]
                                                        }, ${year}`}{" "}
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="col-sub-two"
                                            onClick={() => addFeedback(32)}
                                        >
                                            <div className=" fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    32
                                                </span>
                                                <span className="crisp-label-style"> Signature : </span>
                                            </div>
                                            <div className="fw-bold value-items">
                                                {crispFormDetailsResponse?.InmateSignature && (
                                                    <img
                                                        height={"60px"}
                                                        width={"210px"}
                                                        src={crispFormDetailsResponse?.InmateSignature}
                                                        alt="NotDesireServicesSign"
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-sub-one" onClick={() => addFeedback(33)}>
                                        <div className=" fs-5 mb-0  d-flex ">
                                            <span
                                                {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                    1 && crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? {
                                                        "data-bs-toggle": "modal",
                                                        "data-bs-target":
                                                            "#public-defender-crisp-correction-modal",
                                                    }
                                                    : "")}
                                                className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                                                    crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? "animate-opacity"
                                                    : ""
                                                    }`}
                                            >
                                                33
                                            </span>
                                            <span className="crisp-label-style"> Print Name : </span>
                                        </div>
                                        <span className="fw-bold value-items">
                                            {crispFormDetailsResponse?.InmatePrintName}
                                        </span>
                                    </div>

                                    <div className="col-sub-one">
                                        <div className=" d-flex  border-0 py-0 fw-bold value-items mt-2">
                                            ASSISTANCE: The understated person provided assistance to
                                            the defendant/child with the completion of this form due
                                            the defendant’s inability to read and write.
                                        </div>
                                    </div>

                                    <div className="col-sub-two" onClick={() => addFeedback(34)}>
                                        <div className=" fs-5 mb-0  d-flex ">
                                            <span
                                                {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                    1 && crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? {
                                                        "data-bs-toggle": "modal",
                                                        "data-bs-target":
                                                            "#public-defender-crisp-correction-modal",
                                                    }
                                                    : "")}
                                                className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                                                    crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? "animate-opacity"
                                                    : ""
                                                    }`}
                                            >
                                                34
                                            </span>
                                            <span className="crisp-label-style"> Name : </span>
                                        </div>
                                        <span
                                            className={
                                                crispFormDetailsResponse?.DefendantAssistanceName
                                                    ? "fw-bold value-items"
                                                    : "p-4"
                                            }
                                        >
                                            {crispFormDetailsResponse?.DefendantAssistanceName
                                                ? crispFormDetailsResponse?.DefendantAssistanceName
                                                : "-"}{" "}
                                        </span>
                                    </div>

                                    <div className="col-sub-two" onClick={() => addFeedback(35)}>
                                        <div className=" fs-5 mb-0  d-flex ">
                                            <span
                                                {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                    1 && crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? {
                                                        "data-bs-toggle": "modal",
                                                        "data-bs-target":
                                                            "#public-defender-crisp-correction-modal",
                                                    }
                                                    : "")}
                                                className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff === 1 &&
                                                    crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                    ? "animate-opacity"
                                                    : ""
                                                    }`}
                                            >
                                                35
                                            </span>
                                            <span className="crisp-label-style"> Phone : </span>
                                        </div>
                                        <span
                                            className={
                                                crispFormDetailsResponse?.DefendantAssistancePhone
                                                    ? "fw-bold value-items"
                                                    : "p-4"
                                            }
                                        >
                                            {crispFormDetailsResponse?.DefendantAssistancePhone
                                                ? crispFormDetailsResponse?.DefendantAssistancePhone
                                                : "-"}{" "}
                                        </span>
                                    </div>

                                    <div className="">
                                        <div
                                            className="col-sub-two"
                                            onClick={() => addFeedback(36)}
                                        >
                                            <div className=" fs-5 mb-0  d-flex ">
                                                <span
                                                    {...(crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? {
                                                            "data-bs-toggle": "modal",
                                                            "data-bs-target":
                                                                "#public-defender-crisp-correction-modal",
                                                        }
                                                        : "")}
                                                    className={`round-badge ${crispFormDetailsResponse?.IsFormAcceptPdStaff ===
                                                        1 &&
                                                        crispFormDetailsResponse?.PdsFormOpenStatus === 1
                                                        ? "animate-opacity"
                                                        : ""
                                                        }`}
                                                >
                                                    36
                                                </span>
                                                <span className="crisp-label-style">Address : </span>
                                            </div>
                                            <span
                                                className={
                                                    crispFormDetailsResponse?.DefendantAssistanceAddress
                                                        ? "fw-bold value-items"
                                                        : "p-4 "
                                                }
                                            >
                                                {crispFormDetailsResponse?.DefendantAssistanceAddress
                                                    ? crispFormDetailsResponse?.DefendantAssistanceAddress
                                                    : "-"}
                                            </span>
                                        </div>
                                    </div>


                                    {crispFormDetailsResponse?.IsFormApprovedPdStaff === 1 &&
                                        crispFormDetailsResponse?.PDSFormApprovedBy !== "" && (
                                            <div className="mt-2">
                                                <span className="crisp-label-style">
                                                    {" "}
                                                    Approved By :{" "}
                                                </span>
                                                {loggedUser ===
                                                    crispFormDetailsResponse?.PDSFormApprovedByID
                                                    ? "Self"
                                                    : crispFormDetailsResponse?.PDSFormApprovedBy}
                                            </div>
                                        )}
                                </div>
                                <div className="d-flex flex-wrap justify-content-center gap-3 mt-3">
                                    {/* {crispFormDetailsResponse?.IsFormAcceptPdStaff === 0 && ( */}
                                    {isShowStartProcessingBtn && (
                                        <Button
                                            label="Start Processing"
                                            status="primary"
                                            type="button"
                                            icon={"fa-solid fa-play"}
                                            onClick={() => startProcessing()}
                                        />
                                    )}
                                    {/* )} */}

                                    {isShowResubmitBtn && (
                                        <Button
                                            label={"Re-Submit"}
                                            status="black"
                                            type="button"
                                            icon={"fa-solid fa-rotate-right"}
                                            onClick={() => {
                                                handleResubmit();
                                            }}
                                        />
                                    )}

                                    {isShowApprovedBtn && (
                                        <Button
                                            label={"Approve"}
                                            status="success"
                                            type="button"
                                            icon={"check"}
                                            onClick={() => {
                                                handleApprove();
                                            }}
                                        />
                                    )}

                                    {isShowRejectBtn && (
                                        <Button
                                            label={"Reject"}
                                            status="primary"
                                            type="button"
                                            icon={"close"}
                                            onClick={() => handleReject()}
                                        />
                                    )}

                                    {isShowBackBtn && (
                                        <Button
                                            label={"Back"}
                                            status="secondary"
                                            icon={"fa-solid fa-angle-left"}
                                            type="button"
                                            onClick={() => {
                                                Swal.close();
                                                history?.navigate("StaffRequestList");
                                            }}
                                        />
                                    )}

                                    {/* )} */}
                                </div>
                            </article>
                        </div>
                    </form>
                </div>
            </div>
            {/* {reviewList?.length > 0 && ( */}
            <CommonModal
                modalId="public-defender-crisp-feedback"
                title="Feedback for Resubmission"
                loader={reviewList?.loading}
                bodyContent={<Table columns={feedbackColumn} data={reviewList?.data} />}
                footerContent={
                    <button className="btn button-primary" data-bs-dismiss="modal">
                        Close
                    </button>
                }
            />
            {/* )} */}

            <CommonModal
                modalId="public-defender-crisp-correction-modal"
                title="Add Feedback"
                bodyContent={
                    <div>
                        <div className="d-flex flex-wrap gap-3">
                            {/* <div data-bs-dismiss="modal"> */}
                            <div>
                                <Button
                                    label={"SAVE"}
                                    status="success"
                                    type="submit"
                                    icon={"fa-solid fa-floppy-disk"}
                                    onClick={() => saveFeedBack()}
                                />
                            </div>

                            <Button
                                label="Delete"
                                status="primary"
                                icon={"trash"}
                                type="button"
                                onClick={() => deleteFeedBack()}
                            />
                        </div>
                        <p className="crisp-label-style mt-3">
                            Each item filled by Inmates are associated with a S.no.. Please
                            provide your inputs here mentioning its S.no and this will be
                            reviewed by Inmate upon their login.
                        </p>
                        <Table
                            columns={addFeedBackColumn}
                            data={permananentFeedBackList}
                        />
                    </div>
                }
                closeModalTrigger={closePopup}
                showCloseIcon={false}
            />

            <CommonModal
                modalId="signature-modal"
                title="PLEASE SIGN BELOW INSIDE THE SIGNATURE PAD "
                bodyContent={
                    <div className="p-4 shadow-sm bg-light mb-3">
                        <SignatureCanvas
                            ref={sigCanvas}
                            penColor="black"
                            canvasProps={{
                                width: 900,
                                height: 200,
                                className: "signature-canvas",
                            }}
                        />
                    </div>
                }
                footerContent={
                    <>
                        <button
                            className="btn button-primary"
                            da-bs-dismiss="modal"
                            onClick={() => {
                                clearSignature();
                            }}
                        >
                            Clear
                        </button>
                        <button
                            // data-bs-dismiss="modal"
                            className="btn button-success"
                            onClick={() => saveSignature()}
                        >
                            Submit
                        </button>
                    </>
                }
            />
        </div>
    );
}

export default React.memo(PublicDefenderServiceForm);
